import validation from '../../../../../validation/index.js';
import rules from '../../../../../validation/rules/index.js';
const newPutBodyRules = {
    privacyIssues: rules.object().test('valid-answers-object', 'Invalid answers object structure', obj => {
        if (!obj)
            return false;
        return Object.values(obj).every(value => {
            if (!value || typeof value !== 'object')
                return false;
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            if (!Array.isArray(value.answers))
                return false;
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            return value.answers.every((answer) => typeof answer === 'string');
        });
    }),
};
const putParamRules = {
    id: validation.rules.string().required().label('Organization ID'),
    productId: validation.rules.string().required().label('Product ID'),
};
const putParams = {
    rules: putParamRules,
    schema: validation.schema(putParamRules),
};
const putBody = {
    rules: newPutBodyRules,
    schema: validation.schema(newPutBodyRules),
};
// eslint-disable-next-line import/prefer-default-export
export const put = {
    body: putBody,
    params: putParams,
};
export const get = { params: putParams };
//# sourceMappingURL=validation.js.map